<template>
  <div>
    <!-- Main navbar -->
    <div class="navbar navbar-expand-md navbar-light navbar-static">
      <div class="collapse navbar-collapse" id="navbar-mobile">
        <div class="navbar-brand">
          <a href="index.html" class="d-inline-block">
            <!--TODO: Add logo-->
            <img src="assets/images/tikkerLogo.png" alt="" />
          </a>
        </div>
        <!-- <ul class="navbar-nav">
          <li class="nav-item">
            <a
              href="#"
              class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
            >
              <i class="icon-paragraph-justify3"></i>
            </a>
          </li>
        </ul> -->

        <span class="badge bg-success my-3 my-md-0 ml-md-3 mr-md-auto"
          >Online</span
        >

        <ul class="navbar-nav">
          <li class="nav-item dropdown dropdown-user">
            <a
              href="#"
              class="navbar-nav-link d-flex align-items-center dropdown-toggle"
              data-toggle="dropdown"
            >
              <img src="" class="rounded-circle mr-2" height="34" alt="" />
              <span id="span_email">{{ userEmail }}</span>
            </a>

            <div class="dropdown-menu dropdown-menu-right">
              <a href="#" class="dropdown-item" v-on:click="logout"
                ><i class="icon-switch2"></i> Logout</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="page-content">
      <!-- Main sidebar -->

      <div
        id="sidebar"
        class="sidebar sidebar-light sidebar-main sidebar-expand-md sidebar-fullscreen mobile-sidebar-hidden"
        :style="{ position: this.mobileNavPosition }"
      >
        <!-- Sidebar mobile toggler -->
        <div class="sidebar-mobile-toggler text-center">
          <a
            href="#"
            class="sidebar-mobile-main-toggle"
            @click="toggleMobileNav"
          >
            <i class="icon-arrow-left8"></i>
          </a>
          Navigation
          <a href="#" class="sidebar-mobile-expand"> </a>
        </div>
        <!-- /sidebar mobile toggler -->

        <!-- Sidebar content -->
        <div
          class="sidebar-content"
          :style="{
            left: this.sideBarMobileContentLeft,
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'space-between',
            height: '100vh'
          }"
        >
          <!-- Main navigation -->
          <div class="card card-sidebar-mobile">
            <!-- User menu -->
            <div class="sidebar-user">
              <div class="card-body">
                <div class="media">
                  <div class="mr-3">
                    <a href="#"
                      ><img
                        src="assets/images/tikker_icon.png"
                        width="38"
                        height="38"
                        class="rounded-circle"
                        alt=""
                    /></a>
                  </div>

                  <div class="media-body">
                    <div
                      id="span_header_userName"
                      class="media-title font-weight-semibold"
                    >
                      {{ userName }}
                    </div>
                    <div class="font-size-xs opacity-50">
                      <i
                        id="span_header_userEmail"
                        class="icon-pin font-size-sm"
                      ></i>
                      &nbsp;{{ userEmail }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /user menu -->
            <ul class="nav nav-sidebar" data-nav-type="accordion">
              <!-- Main -->
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'searchTimeCards' }"
                  v-on:click="
                    changePage('searchTimeCards', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-home4"></i>
                  <span>
                    Search Time Cards
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'dailyTimeCards' }"
                  v-on:click="
                    changePage('dailyTimeCards', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-stack"></i>
                  <span>
                    Daily Time Cards
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'unapprovedTimeCards' }"
                  v-on:click="
                    changePage('unapprovedTimeCards', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-stamp"></i>
                  <span>
                    Unapproved Time Cards
                  </span>
                </a>
              </li>
              <li class="nav-item nav-item-submenu">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'payrollReport' }"
                  v-on:click="
                    changePage('payrollReport', $event);
                    expandMenu($event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-address-book"></i>

                  Reports
                </a>
                <ul class="nav nav-group-sub">
                  <li class="list-item">
                    <a
                      href="#"
                      class="nav-link"
                      v-bind:class="{ active: activePage == 'payrollReport' }"
                      v-on:click="
                        changePage('payrollReport', $event);
                        toggleMobileNav();
                      "
                    >
                      <span>
                        Payroll Report
                      </span>
                    </a>
                  </li>
                  <li class="list-item">
                    <a
                      href="#"
                      class="nav-link"
                      v-bind:class="{
                        active: activePage == 'hoursWorkedReport'
                      }"
                      v-on:click="
                        changePage('hoursWorkedReport', $event);
                        toggleMobileNav();
                      "
                    >
                      <span>
                        Employee Hours
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'settings' }"
                  v-on:click="
                    changePage('settings', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-cogs"></i>
                  <span>
                    Settings
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'manageUsers' }"
                  v-on:click="
                    changePage('manageUsers', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-users"></i>
                  <span>
                    Manage Users
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{ active: activePage == 'automation' }"
                  v-on:click="
                    changePage('automation', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-git-branch"></i>
                  <span>
                    Automation
                  </span>
                </a>
              </li>
              <li v-if="jobSpecificTimes" class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  v-bind:class="{
                    active: activePage == 'manageJobsAndCustomers'
                  }"
                  v-on:click="
                    changePage('manageJobsAndCustomers', $event);
                    toggleMobileNav();
                  "
                >
                  <i class="icon-paragraph-justify3"></i>
                  <span>
                    Manage Jobs & Customers
                  </span>
                </a>
              </li>
              <!-- <li class="nav-item" @click="test">
								<a href="#">
									asdf
								</a>
							</li> -->
              <!-- /main -->
            </ul>
          </div>
          <!-- /main navigation -->

          <!-- Time controler -->
          <!-- <div class="time-controler mb-5">
            <timeControlPanel />
          </div> -->
          <!-- /Time controler -->
        </div>
        <!-- /sidebar content -->
      </div>

      <!-- /main sidebar -->
      <div class="content-wrapper">
        <!-- Page header -->
        <div class="page-header border-bottom-0">
          <div class="page-header-content header-elements-md-inline">
            <div class="page-title d-flex">
              <ul class="navbar-nav" id="hamburgerMenu">
                <li class="nav-item">
                  <a
                    href="#"
                    class="navbar-nav-link sidebar-control sidebar-main-toggle d-md-block"
                    @click="toggleMobileNav"
                  >
                    <i class="icon-paragraph-justify3"></i>
                  </a>
                </li>
              </ul>
              <h4 id="span_companyName">
                <span class="font-weight-semibold">Tikker</span> -
                {{ this.$store.state.userCompanyName }}
              </h4>
              <!-- <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a> -->
            </div>
          </div>
        </div>
        <!-- /page header -->

        <div class="content pt-o">
          <div class="row">
            <div class="col-12">
              <searchTimeCards v-if="activePage == 'searchTimeCards'" />
              <manageUsers v-if="activePage == 'manageUsers'" />
              <automation v-if="activePage == 'automation'" />
              <manageJobsAndCustomers
                v-if="activePage == 'manageJobsAndCustomers'"
              />
              <dailyTimeCards v-if="activePage == 'dailyTimeCards'" />
              <payrollReport v-if="activePage == 'payrollReport'" />
              <payrollReportv2 v-if="activePage == 'payrollReportv2'" />
              <hoursWorkedReport v-if="activePage == 'hoursWorkedReport'" />
              <unapprovedTimeCards v-if="activePage == 'unapprovedTimeCards'" />
              <settings v-if="activePage == 'settings'" />
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div class="navbar navbar-expand-lg navbar-light">
          <div class="text-center d-lg-none w-100">
            <button
              type="button"
              class="navbar-toggler dropdown-toggle"
              data-toggle="collapse"
              data-target="#navbar-footer"
            >
              <i class="icon-unfold mr-2"></i>
              Footer
            </button>
          </div>

          <div class="navbar-collapse collapse" id="navbar-footer">
            <span class="navbar-text">
              Super Slick Software by
              <a href="https://ce-solutions.ca">CE Solutions Ltd.</a>
            </span>

            <ul class="navbar-nav ml-lg-auto"></ul>
          </div>
        </div>
        <!-- /footer -->
      </div>
    </div>
  </div>
  <!-- /main navbar -->
</template>

<script>
import searchTimeCards from '../components/searchTimeCards.vue';
import manageUsers from '../components/manageUsers.vue';
import automation from '../components/automation.vue';
import manageJobsAndCustomers from './manageJobsAndCustomers.vue';
import dailyTimeCards from '../components/dailyTimeCards.vue';
import payrollReport from '../components/reports/payrollReportv2.vue';
import hoursWorkedReport from '../components/reports/hoursWorkedReport.vue';
import settings from '../components/settings.vue';
import unapprovedTimeCards from '../components/unapprovedTimeCards.vue';
import { mapState } from 'vuex';
import { auth } from '../assets/js/firebase/db.js';
// import timeControlPanel from './timeControlPanel.vue';

export default {
  name: 'headerComp',
  components: {
    searchTimeCards,
    manageUsers,
    automation,
    manageJobsAndCustomers,
    dailyTimeCards,
    payrollReport,
    settings,
    unapprovedTimeCards,
    hoursWorkedReport,
    // timeControlPanel
  },
  data() {
    return {
      activePage: 'unapprovedTimeCards',
      mobileNavPosition: 'static',
      sideBarMobileContentLeft: null
    };
  },
  methods: {
    changePage: function(page, e) {
      //check to see if the parent li has the nav-item-subment class.
      if (!e.target.closest('li').classList.contains('list-item')) {
        //this is a submenu. close alls submenus.
        let sidebar = document.getElementsByClassName('sidebar')[0];

        var openMenus = sidebar.querySelectorAll(
          '.nav-item-submenu.nav-item-open'
        );

        openMenus.forEach.call(openMenus, function(el) {
          el.classList.remove('nav-item-open');
          el.getElementsByTagName('ul')[0].style.display = 'none';
        });
      }

      this.activePage = page;
      //Clearing the totals on page changed, because the totals woudld add up from other pages.
      this.$store.commit('clearTotals');
    },
    logout: function() {
      auth.signOut().then(() => {
        //clear logo meta data so we don't get logos mixed up if a user is swithcing comanies for some reason and the new company does not have a logo.
        this.$store.commit('clearLogoMetaData');
      });
    },
    expandMenu: function(e) {
      if (e.target.nodeName == 'I') {
        if (
          e.target.parentElement.parentElement.classList.contains(
            'nav-item-open'
          )
        ) {
          //remove the nav-item-open class to compress the menu.
          e.target.parentElement.parentElement.classList.remove(
            'nav-item-open'
          );
          e.target.parentElement.parentElement.getElementsByTagName(
            'ul'
          )[0].style.display = 'none';
        } else {
          //if the element that called this ins't an expandable menu, then we need to close all expandable menus.

          //add the nav-item-open class to expand the menu.
          e.target.parentElement.parentElement.classList.add('nav-item-open');
          //this is the child ul.
          e.target.parentElement.parentElement.getElementsByTagName(
            'ul'
          )[0].style.display = 'block';
        }
      } else {
        if (e.target.parentElement.classList.contains('nav-item-open')) {
          //remove the nav-item-open class to compress the menu.
          e.target.parentElement.classList.remove('nav-item-open');
          e.target.parentElement.getElementsByTagName('ul')[0].style.display =
            'none';
        } else {
          //if the element that called this ins't an expandable menu, then we need to close all expandable menus.

          //add the nav-item-open class to expand the menu.
          e.target.parentElement.classList.add('nav-item-open');
          //this is the child ul.
          e.target.parentElement.getElementsByTagName('ul')[0].style.display =
            'block';
        }
      }
    },
    toggleMobileNav: function() {
      let sidebar = document.getElementsByClassName('sidebar-main');
      if (sidebar[0].classList.contains('mobile-sidebar-hidden')) {
        sidebar[0].classList.add('mobile-sidebar-shown');
        sidebar[0].classList.remove('mobile-sidebar-hidden');
        this.sideBarMobileContentLeft = 0;
      } else if (sidebar[0].classList.contains('mobile-sidebar-shown')) {
        sidebar[0].classList.add('mobile-sidebar-hidden');
        sidebar[0].classList.remove('mobile-sidebar-shown');
      }
    }
  },
  computed: mapState(['userName', 'userEmail', 'jobSpecificTimes'])
};
</script>

<style scoped>
#hamburgerMenu {
  margin-top: -10px;
}
</style>
